
    <div *ngIf="loading">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      Loading please wait
    </div>
  